exports.components = {
  "component---src-gg-templates-tsx-tsx": () => import("./../../../src/gg/templates/tsx.tsx" /* webpackChunkName: "component---src-gg-templates-tsx-tsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */)
}

